import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export default function Testimonials() {
  const { data: items = [] } = useQuery({ queryKey: ["ts"], queryFn: () => api.get("/testimonials", { params: { is_active: true, limit: 60 } }).then((r) => r.data.items) });
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-[0.24em] text-amber-600 mb-4">Testimonials</div>
        <h1 className="font-display text-5xl sm:text-6xl text-slate-950 leading-none">Guest stories.</h1>
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t) => (
            <div key={t.id} className="bg-white rounded-2xl border border-slate-200 p-6" data-testid={`ts-${t.id}`}>
              <div className="flex items-center gap-1 text-amber-500">{Array.from({ length: t.rating || 5 }).map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-500" />)}</div>
              <p className="mt-5 text-slate-700 leading-relaxed">“{t.message}”</p>
              <div className="mt-6 border-t border-slate-200 pt-4">
                <div className="text-slate-950 font-medium text-sm">{t.name}</div>
                <div className="text-slate-500 text-xs">{t.location}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
